/* =========================================================================
   One-click "quick add" binder (CRO §02.5 / §04.3). Binds [data-af-cross-add]
   buttons inside any [data-handle] container — PDP "Pair with" cards
   (.af-cross-item) and collection-grid cards (.af-plp-card). Fetches the
   product's variant data from /products/{handle}.js (cached per handle) and
   opens the shared AFQuickPick popover so the shopper picks size/colour and
   adds without leaving the page. The add itself refreshes + opens the cart
   drawer (see af-quick-pick.js).
   ========================================================================= */
(function () {
  var cache = {};

  function closeOthers(except) {
    document.querySelectorAll('[data-handle] .af-xsell-pick').forEach(function (x) {
      if (x !== except) { x.hidden = true; x.innerHTML = ''; }
    });
  }

  function init() {
    document.querySelectorAll('[data-af-cross-add]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var item = btn.closest('[data-handle]');
        if (!item) return;
        var pick = item.querySelector('.af-xsell-pick');
        closeOthers(pick);
        if (!pick.hidden) { pick.hidden = true; pick.innerHTML = ''; return; }
        var handle = item.getAttribute('data-handle');
        var load = cache[handle]
          ? Promise.resolve(cache[handle])
          : fetch('/products/' + handle + '.js').then(function (r) { return r.json(); }).then(function (p) { cache[handle] = p; return p; });
        btn.disabled = true;
        load.then(function (p) {
          btn.disabled = false;
          /* Optional per-variant quantity map (JSON {variantId: qty}) — lets a
             grid quick-add whole cases (kids bulk LP). Absent = qty 1. */
          var qtyMap = null;
          try { qtyMap = JSON.parse(item.getAttribute('data-af-qty-map') || 'null'); } catch (e) {}
          window.AFQuickPick.open(pick, p, {
            preferVariantId: item.getAttribute('data-preferred-variant'),
            qtyFor: qtyMap ? function (id) { return qtyMap[String(id)] || 1; } : null,
            source: item.classList.contains('af-plp-card') ? 'plp-quickadd' : 'pdp-xsell',
            onAdded: function (v, err) {
              pick.hidden = true; pick.innerHTML = '';
              var original = btn.textContent;
              btn.textContent = err ? 'Not enough stock' : 'Added ✓';
              setTimeout(function () { btn.textContent = original; }, 1600);
            }
          });
        }).catch(function () { btn.disabled = false; });
      });
    });
  }

  if (document.readyState !== 'loading') init();
  else document.addEventListener('DOMContentLoaded', init);
})();
